import SmarttenderApi from '@/api/smarttenderApi'
const tender_api = new SmarttenderApi()

const SET_SPR_USERS = 'SET_SPR_USERS'
const SET_SPR_USERS_LOADING = 'SET_SPR_USERS_LOADING'
const SET_SPR_HASH = 'SET_SPR_HASH'
const SET_MODEL_INNER_CHAT = 'SET_MODEL_INNER_CHAT'
const SET_VIEW_CHAT_MESSAGES = 'SET_VIEW_CHAT_MESSAGES'
const SET_VIEW_CHAT_MESSAGES_NOTIFY = 'SET_VIEW_CHAT_MESSAGES_NOTIFY'

export default {
  namespaced: true,
  state: {
    sprUsers: [],
    sprUsersLoading: false,
    sprHashItems: [],
    innerChat: {
      chatId: null,
      chatKey: null,
      chatType: 'TENDER',
      skip: 0,
      take: 10,
      messagesCount: 0,
      unreadCount: 0,
      messages: [],
    },
  },
  getters: {
    innerChat: (state) => state.innerChat,
    sprUsers: (state) => state.sprUsers,
    sprUsersLoading: (state) => state.sprUsersLoading,
    sprHashItems: (state) => state.sprHashItems,
  },
  mutations: {
    [SET_SPR_USERS](state, items) {
      state.sprUsers = items
    },
    [SET_SPR_USERS_LOADING](state, items) {
      state.sprUsersLoading = items
    },
    [SET_SPR_HASH](state, items) {
      state.sprHashItems = items
    },
    [SET_MODEL_INNER_CHAT](state, items) {
      state.innerChat = items
    },
    [SET_VIEW_CHAT_MESSAGES](state, model) {
      if (state.innerChat.chatKey === model.key && state.innerChat.chatType === model.type) {
        model.messageIds.forEach(messageId => {
          const message = state.innerChat.messages.find(i => i.id === messageId)
          if (message) {
            message.isViewed = true
            state.innerChat.unreadCount--
          }
        })
      }
    },
    [SET_VIEW_CHAT_MESSAGES_NOTIFY](state, items) {
      items?.forEach((subscribleEntitie) => {
        if (subscribleEntitie.subscriptionEntityId === state.innerChat.subscriptionEntityId) {
          subscribleEntitie.messages?.forEach((subscribleMessage) => {
            const message = state.innerChat.messages.find(i => i.id === subscribleMessage.messageId)
            if (message) {
              message.isViewed = true
              state.innerChat.unreadCount--
            }
          })
        }
      })
    }
  },
  actions: {
    async getSprUser({getters, commit}) {
      if (!getters.sprUsers?.length && !getters.sprUsersLoading) {
        commit(SET_SPR_USERS_LOADING, true)
        return await tender_api.tenderContactPersons()
          .then(async (response) => {
            commit(SET_SPR_USERS, response)
          })
          .finally(() => {
            commit(SET_SPR_USERS_LOADING, false)
          })
      } else {
        return getters.sprUsers
      }
    },
    setSprHash({ commit }, { items }) {
      commit(SET_SPR_HASH, items)
    },
    setModelInnerChat({ commit }, { model }) {
      commit(SET_MODEL_INNER_CHAT, model)
    },
    setViewMessages({ commit }, { model }) {
      commit(SET_VIEW_CHAT_MESSAGES, model)
    },
    setViewMessages_notify({ commit }, { items }) {
      commit(SET_VIEW_CHAT_MESSAGES_NOTIFY, items)
    },
  }
}